export function normalizeDeployEnvironment(raw) {
    const value = (raw ?? "development").trim().toLowerCase();
    if (value === "staging" || value === "stage") {
        return "staging";
    }
    if (value === "production" || value === "prod") {
        return "production";
    }
    return "development";
}
export function shouldShowDeployEnvBanner(deployEnv) {
    return deployEnv === "staging" || deployEnv === "development";
}
export function deployEnvBannerCopy(deployEnv) {
    if (!shouldShowDeployEnvBanner(deployEnv)) {
        return null;
    }
    if (deployEnv === "staging") {
        return {
            headline: "Private staging environment",
            detail: "For internal agency review only — not public launch or customer production.",
        };
    }
    return {
        headline: "Local development environment",
        detail: "For engineering and agency testing only — not public launch or customer production.",
    };
}
//# sourceMappingURL=deploy-env.js.map